import React from 'react';

export default props => {
  return (<div>
    {props.randomization_platform_step_3_withdraw_content ? <div dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_withdraw_content}} /> :

    <div style={{textAlign: 'justify'}}>
        <h4 align="center">RESEARCH PARTICIPANT INFORMATION AND CONSENT FORM</h4>
        <h4 align="center">(Participant Information and Consent for Sub Study Survey)</h4>
        <table style={{ width: '100%', textAlign: 'left'}}>
            <tbody>
                <tr>
                    <td style={{ width: '30%' }} valign="top">Title of Study</td>
                    <td style={{ width: '70%' }} valign="top">Alteplase Compared to Tenecteplase in patients with Acute Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic Randomized Controlled Trial</td>
                </tr>
                <tr>
                    <td style={{ width: '30%' }} valign="top">Protocol number</td>
                    <td style={{ width: '70%' }} valign="top">AcT 01.6 Original Protocol</td>
                </tr>
                <tr>
                    <td style={{ width: '30%' }} valign="top">Principal Investigator</td>
                    <td style={{ width: '70%' }} valign="top">
                        <b>Dr. Jai Jai Shiva Shankar</b><br/>
                        Rady Faculty of Health Sciences<br/>
                        University of Manitoba<br/>
                        Room 807K-JBRC/715 Mc Dermot Avenue<br/>
                        Winnipeg, MB R3E 3P5<br/>
                        Phone: +1-431-373-4164<br/>
                    </td>
                </tr>
                <tr>
                    <td style={{ width: '30%' }} valign="top">Sponsor</td>
                    <td style={{ width: '70%' }} valign="top">
                    <b>Dr. Bijoy Menon</b><br/>
                        University of Calgary<br/>
                        Foothills Medical Center<br/>
                        1403 29th Street NW<br/>
                        Calgary, AB, T2N 2T9
                    </td>
                </tr>
            </tbody>
        
        </table>
        <br/>
        <p>This consent form, a copy of which has been given to you, is only part of the process of informed consent. It should give you the basic idea of what the research is about and what your participation will involve. If you would like more detail about something mentioned here, or information not included here, you should feel free to ask. Please take the time to read this carefully and to understand any accompanying information.</p>

        <p><u>Purpose</u></p>
        <p>You are being asked to take part in this study because you have had an acute ischemic stroke and you were enrolled in the AcT study by deferral of consent. The aim of this study is to determine how much you understand about the AcT study, how you felt about being enrolled by deferral of consent, and what you think about deferral of consent in general.</p>
        <p>You will have been asked separately to consent to ongoing participation in that study. Now you are being asked to consent to completing a brief questionnaire about your experiences with the AcT study.</p>
        <p>You may consent to participate in the AcT study and not consent to complete this questionnaire.</p>
        <p>You may withdraw consent from the AcT study and not consent to complete this questionnaire.</p>
        <p>You may withdraw consent from the AcT study but consent to complete this questionnaire.</p>
        <p>Whether or not you participate in this study will have no impact on your clinical care.</p>
        <br/>

        <p><u>Risks and Benefits</u></p>
        <p>We do not anticipate any risks related to completing this questionnaire, though you could find the questions difficult or upsetting.</p>
        <p>We do not anticipate any direct benefits to you of completing this questionnaire.</p>
        <p>There is no compensation for completing this questionnaire.</p>
        <br/>

        <p><u>Confidentiality</u></p>
        <p>During the study we will NOT be collecting health data about you. Your responses will be stored using a unique identifier number, not your name. No data relating to this study that includes your name will be released to anyone outside of the research team, nor will it be published by the researchers.</p>
        <br/>

        <p><u>Questions</u></p>
        <p>You are free to ask any questions that you may have about your treatment and your rights as a research participant. If any questions come up during or after the study or if you have a research-related injury, contact the study doctor and the study staff: Dr. Jai Jai Shiva Shankar at 1-431-373-4164</p>
        <p>For questions about your rights as a research participant, you may contact The University of Manitoba Biomedical Research Ethics Board at (204) 789-3389</p>
        <p>Do not sign this consent form unless you have had a chance to ask questions and have received satisfactory answers to all of your questions.</p>


        <p><b><u>Statement of Consent</u></b></p>
        <ul style={{ fontWeight: 'bold'}}>
            <li>I have read this consent form. I have had the opportunity to discuss this research study with Dr. Jai Jai Shiva Shankar and or his study staff. I have had my questions answered by them in language I understand. The risks and benefits have been explained to me. I believe that I have not been unduly influenced by any study team member to participate in the research study by any statement or implied statements. Any relationship (such as employee, student or family member) I may have with the study team has not affected my decision to participate. I understand that I will be given a copy of this consent form after signing it. I understand that my participation in this clinical trial is voluntary and that I may choose to withdraw at any time. I freely agree to participate in this research study.</li>
            <li>I understand that information regarding my personal identity will be kept confidential, but that confidentiality is not guaranteed. I authorize the inspection of my medical records by Dr. Bijoy Menon, University of Calgary, the Food and Drug Administration, the Health Protection Branch, government agencies in other countries, and The University of Manitoba Biomedical Research Ethics Board.</li>
            <li>By signing this consent form, I have not waived any of the legal rights that I have as a participant in a research study.</li>
        </ul>

        <br/><br/><br/>
      </div>
    }
  </div>);
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeWinnipeg/Texts/SubstudyText.js